<i class="bi bi-arrow-down-up text-primary" *ngIf="!enable"></i>
<i
  class="bi bi-sort-alpha-down text-primary"
  *ngIf="enable && direction == 'ASC'"
></i>
<i
  class="bi bi-sort-alpha-up text-primary"
  *ngIf="enable && direction == 'DESC'"
></i>
